




















































import FieldGenerator           from "@/components/pageGenerator/FieldGenerator.vue";
import { PageScheme }           from "@/components/pageGenerator/models";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name      : "PageGenerator",
  components: {FieldGenerator}
})
export default class PageGenerator extends Vue {
  private formData = {};
  @Prop({
    required: true,
    type    : Object as () => PageScheme,
    default : {}
  })
  private page!: PageScheme;

  @Prop({
    required: true,
    type    : Boolean,
    default : true
  })
  private showBackgroundImage!:boolean
  public iframe: string | (string | null)[]          = "0";
  private onSubmit(): void {
    if(!(this.$refs.pageForm as HTMLFormElement).validate()){
      return;
    }
    let myForm = document.getElementById('frm') as HTMLFormElement;
    let formData = new FormData(myForm);
    const data = {};
    // need to convert it before using not with XMLHttpRequest
    for (let [key, val] of formData.entries()) {
      Object.assign(data, {[key]: val})
    }
    console.log(data);
    this.$emit("submit", data);
  }

  created(): void {
    this.iframe = this.$route.query.iframe
  }

  validate(){
    (this.$refs.pageForm as HTMLFormElement).validate();
  }
}
